/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable complexity */
import CardWrapper from '../wrapper/card';
import ComposeBulkEmailComponent from './email_compose';
import { fetchLeadsThunk } from '../../redux/thunks/lead';
import FormMapping from './mapping';
import { formSettingsThunk } from '../../redux/thunks/form';
import { LeadObject } from '../../params/redux/leads';
import { parseFormConfigData } from '../../helper/form_builder';
import SettingsComponent from './settings';
import SMSBulkComposeComponent from './send_sms';
import { styled } from '@mui/material/styles';
import SubmissionsComponent from './submissions';
import { useParams } from 'react-router';
import { a11yProps, CustomTabPanel } from '../../pages/deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Switch, Tab, Tabs, Typography } from '@mui/material';
import { brand, green, red } from '../../theme/themePrimitives';
import { CompareArrows, EditOutlined, KeyboardArrowLeft, UploadOutlined } from '@mui/icons-material';
import { FormObject, FormSettingsParams } from '../../params/redux/form';
import { settingCreateFormFlag, settingFormFieldObject, settingFormManualMapping, settingSelectedForm, settingSelectedFormFlag } from '../../redux/slices/form';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import CustomTooltip from '../reusable/custom_tooltip';
import { toast } from 'react-toastify';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '300ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: green[400],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

const exportToCSV = (rows: LeadObject[], fileName: string) => {
    if (!rows) {
        console.error('No data available to export.');
        return;
    }
    const escapeCSVValue = (value: string | number) => {
        if (!value) return '""';
        const str = String(value).replace(/"/gu, '""');
        return `"${str}"`;
    };
    const csvHeaders = ['Email', 'Phone'];

    const csvRow = [...rows].map((row) => ([
        escapeCSVValue(row.email || '-'),
        escapeCSVValue(row.phone || '-')
    ]));
    const csvContent = [csvHeaders.join(','), csvRow.join(',')].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const SelectedFormComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [selectedTab, setSelectedTab] = useState<0 | 1>(0);
    const { leads, bulkMessage } = useSelector((state: RootState) => state.lead);
    const { selectedForm, manual } = useSelector((state: RootState) => state.form);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const filteredLeads = leads.filter((lead: LeadObject) => lead.form_id === selectedForm?.id);

    useEffect(() => {
        const fetchLeads = async () => {
            try {
                await dispatch(fetchLeadsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                //
            }
        };
        fetchLeads();
    }, [id]);

    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
        setSelectedTab(newValue);
    };

    const navigateBackHandler = () => {
        dispatch(settingSelectedForm(null));
        dispatch(settingSelectedFormFlag(false));
    };

    const handleEditForm = async () => {
        const formField = await parseFormConfigData(selectedForm as FormObject);
        dispatch(settingSelectedForm(selectedForm));
        dispatch(settingFormFieldObject(formField));
        dispatch(settingCreateFormFlag(true));
        dispatch(settingSelectedFormFlag(false));
    };

    const updateStatusFormHandler = async () => {
        try {
            const data: FormSettingsParams = {
                form_id: selectedForm?.id || 0,
                status: selectedForm?.status === 'inactive' ? 'active' : 'inactive',
                pipeline_id: selectedForm?.pipeline_id || 0,
                stage_id: selectedForm?.stage_id || 0,
                client_id: selectedForm?.client_id || 0,
                redirect_url: selectedForm?.redirect_url || ''
            };
            await dispatch(formSettingsThunk(data)).unwrap();
        } catch (e) {
            //
        }
    };

    const handleManualLeads = async (form: FormObject) => {
        const formLeads: LeadObject[] = await leads.filter((lead: LeadObject) => lead.form_id === form.id);
        const customToLabel = {
            title: 'Title',
            email: 'Email',
            company: 'Company Name',
            phone: 'Phone Number',
            address: 'Address',
            country: 'Country',
            zip: 'Zip',
            state: 'State',
            city: 'City'
        } as const;
        type MappingJson = Record<keyof typeof customToLabel, string | null>;
        const mappingJson: MappingJson = form.mapping_json
            ? JSON.parse(form.mapping_json)
            : {
                title: null,
                email: null,
                company: null,
                phone: null,
                address: null,
                country: null,
                zip: null,
                state: null,
                city: null
            };


        const headerToFieldId: any =
            Object.fromEntries((Object.entries(mappingJson) as [keyof typeof customToLabel, string | null][])
                // for each [fieldKey, formFieldId]
                .map(([fieldKey, formFieldId]) => [
                    customToLabel[fieldKey],
                    formFieldId
                ]));

        if (form.type === 'internal') {
            dispatch(settingFormManualMapping({
                selectedForm: form,
                isManual: true,
                selectedLeads: formLeads,
                headers: JSON.parse(form.form_json).fields.map((field: any) => field.id),
                rows: JSON.parse(form.form_json).fields.filter((field: any) => field.type !== 'submit'),
                mapping: form.mapping_json ? headerToFieldId : {}
            }));
        } else if (form.type === 'external') {
            dispatch(settingFormManualMapping({
                selectedForm: form,
                isManual: true,
                selectedLeads: formLeads,
                headers: JSON.parse(formLeads[0].form_data).map((field: any) => field.name),
                rows: JSON.parse(formLeads[0].form_data).map((field: any) => ({
                    label: field.name,
                    id: field.name
                })),
                mapping: form.mapping_json ? headerToFieldId : {}
            }));
        } else if (form.type === 'snapps' || form.type === 'snapps-manual' || form.type === 'elementor' || form.type === 'elementor-manual') {
            const parsed = JSON.parse(formLeads[0].form_data);
            const headers = Object.keys(parsed);
            const rows = headers.map((key) => ({
            id: key,
            label: key,
            value: parsed[key as keyof typeof parsed]
            }));
            dispatch(settingFormManualMapping({
                selectedForm: form,
                isManual: true,
                selectedLeads: formLeads,
                headers,
                rows,
                mapping: form.mapping_json ? headerToFieldId : {}
            }));
        }
    };

    if (manual.isManual && manual.selectedForm) {
        return <FormMapping />;
    }
    if (bulkMessage.type === 'email') {
        return <CardWrapper minHeight="80vh" overflow="auto"><ComposeBulkEmailComponent /></CardWrapper>;
    } else if (bulkMessage.type === 'sms') {
        return <CardWrapper minHeight="80vh" overflow="auto"><SMSBulkComposeComponent /></CardWrapper>;
    }

    return (
        <CardWrapper minHeight="80vh" overflow="auto">
            <Box>
                <Button variant="text" color="secondary" startIcon={<KeyboardArrowLeft />} onClick={navigateBackHandler} >Back</Button>
            </Box>
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                aria-label="Leads and Forms details tabs"
            >
                <Tab
                    label="Submissions"
                    {...a11yProps(0)}
                />
                {(currentUser?.id === selectedForm?.user_id && selectedForm?.type !== 'elementor' && selectedForm?.type !== 'snapps' && selectedForm?.type !== 'custom' && selectedForm?.status !== 'deleted') && <Tab
                    label="Settings"
                    {...a11yProps(1)}
                />}
            </Tabs>
            <CardWrapper>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" alignItems="center" gap={1}><Box>
                        <Typography variant="subtitle1" color="textSecondary">{selectedForm?.title}</Typography>
                        <Typography variant="subtitle2" color="textSecondary">Created By: <Typography component="span" variant="subtitle2" color={brand[300]}>{selectedForm?.title}</Typography></Typography>
                    </Box>
                        {(currentUser?.id === selectedForm?.user_id && selectedForm?.type !== 'elementor' && selectedForm?.type !== 'snapps' && selectedForm?.type !== 'snapps-manual' && selectedForm?.type !== 'elementor-manual' && selectedForm?.type !== 'custom' && selectedForm?.type !== 'external') && <IOSSwitch
                            checked={selectedForm?.status === 'active'}
                            disabled={selectedForm?.status === 'deleted'}
                            onChange={updateStatusFormHandler}
                        />}
                        {(currentUser?.id === selectedForm?.user_id && selectedForm?.type !== 'elementor' && selectedForm?.type !== 'snapps' && selectedForm?.type !== 'custom' && selectedForm?.type !== 'snapps-manual' && selectedForm?.type !== 'elementor-manual' && selectedForm?.type !== 'external') && <Box marginY="14px" bgcolor={selectedForm?.status === 'active' ? green[100] : red[100]} color={selectedForm?.status === 'active' ? green[300] : red[300]} display="flex" alignItems="center" width="max-content" borderRadius={1} px={2} paddingY="2px">
                            <Typography variant="body1" fontWeight="bold">{selectedForm?.status.toLocaleUpperCase()}</Typography>
                        </Box>}
                    </Box>
                    <Box display="flex" gap={2}>
                       {selectedForm?.type !== 'internal' && filteredLeads.length === 0
                       ? <CustomTooltip title="You have to submit at least one lead">
                        <Button variant="outlined" startIcon={<CompareArrows />} onClick={() => toast.error('You have to submit at least one lead', {
                            position: 'top-left',
                            theme: 'dark'
                        })}>Mapping</Button>
                        </CustomTooltip>
                        : <Button variant="outlined" disabled={selectedForm?.type !== 'internal' && filteredLeads.length === 0} startIcon={<CompareArrows />} onClick={() => handleManualLeads(selectedForm as FormObject)}>Mapping</Button>}
                        <Button variant="outlined" startIcon={<UploadOutlined />} onClick={() => exportToCSV(filteredLeads as LeadObject[], selectedForm?.title || 'Unknown')}>Export to CSV</Button>
                        {(currentUser?.id === selectedForm?.user_id && selectedForm?.type !== 'custom' && selectedForm?.type !== 'snapps' && selectedForm?.type !== 'elementor' && selectedForm?.type !== 'snapps-manual' && selectedForm?.type !== 'elementor-manual' && selectedForm?.type !== 'external' && selectedForm?.status !== 'deleted') && <Button variant="outlined" startIcon={<EditOutlined />} onClick={handleEditForm}>Edit this form</Button>}
                    </Box>
                </Box>

                <CustomTabPanel value={selectedTab} index={0}>
                    <SubmissionsComponent />
                </CustomTabPanel>

                {(currentUser?.id === selectedForm?.user_id && selectedForm?.type !== 'elementor' && selectedForm?.type !== 'snapps' && selectedForm?.type !== 'custom' && selectedForm?.status !== 'deleted') && <CustomTabPanel value={selectedTab} index={1}>
                    <SettingsComponent />
                </CustomTabPanel>}
            </CardWrapper>
        </CardWrapper>
    );
};

export default SelectedFormComponent;